<template>
  <form id="payment-form">

    <div id="payment-element" ref="payment-element"></div>

    <div v-if="isLoading" class="flex w-full justify-center mt-4">
      <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-100 fill-sky-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
      </svg>
      <span>{{ $t('loading') }}</span>
    </div>
    <div class="flex justify-center mt-4">
      <button @click.stop.prevent="savePayment()"
        class="px-3 py-1 border rounded-md uppercase w-fit font-medium
        border-sky-400/90 text-sky-400/90 hover:bg-sky-400/90 hover:text-white dark:hover:text-slate-700"
        id="card-button"
      >
        {{ $t('customerDashboard.save_new_payment') }}
      </button>
    </div>

  </form>
</template>

<script>

import { mapActions } from 'vuex';

// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);

export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      paymentElement: null,
      intent: null,
      elements: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('customers', [
      'getCustomerStripeIntent',
      'updatePaymentMethod',
      'getPaymentMethods',
    ]),
    init() {
      this.isLoading = true;
      const elementOptions = {
        mode: 'setup',
        currency: 'eur',
        paymentMethodTypes: ['card', 'sepa_debit'],
        locale: this.$i18n.locale,
      };
      this.displayCard(elementOptions);
      this.isLoading = false;
    },
    async displayCard(elementOptions) {
      this.elements = stripe.elements(elementOptions);
      this.paymentElement = this.elements.create('payment', {
        fields: {
          billingDetails: 'never',
        },
      });

      this.paymentElement.mount('#payment-element');
    },
    async savePayment() {
      this.isLoading = true;
      // Trigger form validation and wallet collection
      const { error: submitError } = await this.elements.submit();

      if (submitError) {
        this.toast.error(this.$t('stripe.error_element'));
        this.isLoading = false;
        return;
      }

      this.intent = await this.getCustomerStripeIntent(this.customer.id);

      // Use the clientSecret and Elements instance to confirm the setup
      try {
        const { setupIntent, error } = await stripe.confirmSetup({
          elements: this.elements,
          clientSecret: this.intent.client_secret,
          confirmParams: {
            // required if automatic_payment_methods is enabled in setupIntent method on backend side
            // return_url: `${window.location.origin}/customer-payment-data/completed`,
            payment_method_data: {
              billing_details: {
                name: this.customer.company,
                email: this.customer.email,
                phone: this.customer.billing_address.phone,
                address: {
                  city: this.customer.billing_address.city,
                  country: this.customer.billing_address.country,
                  line1: this.customer.billing_address.address,
                  line2: '',
                  postal_code: this.customer.billing_address.postcode,
                  state: this.customer.billing_address.state,
                },
              },
            },
          },
          // Uncomment below if you only want redirect for redirect-based payments
          redirect: 'if_required',
        });

        if (error) {
          this.toast.error(`Error after confirmSetup\n ${error.message}`);
          this.isLoading = false;
          return;
        }

        await this.updatePaymentMethod({ id: this.customer.id, paymentMethod: setupIntent.payment_method });
      } catch (err) {
        this.toast.error(`Error trying confirmSetup\n ${err.message}`);
      }
      this.isLoading = false;
      this.$emit('close');
    },
  },
};
</script>
